module.exports = __webpack_public_path__ + "static/alabi-f80557e39dec8c2cc2f3b91cc7c53ad9.jpg";